module.exports = __webpack_public_path__ + "./joy_b7b693de9d14ba6c7583e124d70c5588.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2018/joy.png
// module id = 471
// module chunks = 0